<script setup lang="ts">
import { PhCube as CubeIcon } from '@phosphor-icons/vue'
import { ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    src: string
    alt: string
    position?: string
    eager?: boolean
  }>(),
  {
    position: 'center',
    eager: false,
  },
)

const imageFailed = ref(false)
watch(
  () => props.src,
  () => {
    imageFailed.value = false
  },
)
</script>

<template>
  <div class="product-image" :class="{ 'product-image--fallback': imageFailed }">
    <img
      v-if="!imageFailed"
      :src="src"
      :alt="alt"
      :loading="eager ? 'eager' : 'lazy'"
      :fetchpriority="eager ? 'high' : 'auto'"
      :style="{ objectPosition: position }"
      @error="imageFailed = true"
    />
    <div v-else class="product-image__fallback" role="img" :aria-label="`${alt}图片待替换`">
      <CubeIcon :size="44" weight="duotone" aria-hidden="true" />
      <span>产品图片待替换</span>
    </div>
  </div>
</template>
